export const stubAgency = {
  name: 'ACORN',
  id: '00000000-0000-0000-0000-000000000000',
};
